import React from 'react';
import PropTypes from 'prop-types';
import Modal from 'Components/Modal';
import EnvironmentManager from 'Utils/environmentManager';
import { useDispatch } from 'react-redux';
import { closeModal } from 'Store/actions';

const PrizeInfoModal = props => {
  const dispatch = useDispatch();
  const modalKey = 'ScratchCardInfoModal';

  return (
    <Modal
      title={ EnvironmentManager.getMessageText({ key: 'title_scratch_award_information' }) || 'İkramiye Bilgileri' }
      type="success"
      onClose={ () => dispatch(closeModal(modalKey)) }
      buttonArea={ {
        primaryButton: {
          onClick: () => dispatch(closeModal(modalKey)),
          label: EnvironmentManager.getMessageText({ key: 'button_scratch_okay' }) || 'Tamam'
        }
      } }
    >
      <div className='scratch-list__modal-header'>
        <div className='scratch-list__modal-header__text1'>
          <span>{ EnvironmentManager.getMessageText({ key: 'title_scratch_award_information_awards' }) || 'İKRAMİYELER' }</span>
        </div>
        <div className='scratch-list__modal-header__text2'>
          <span>{ EnvironmentManager.getMessageText({ key: 'title_scratch_award_information_count' }) || 'ADET' }</span>
        </div>

      </div>

      { props?.prizeData?.map((item, index) => {
        return (
          <div className='scratch-my-cards__card--table--row' key={ index }>
            <div className='scratch-my-cards__card--table--row__date'>{ item.prize } </div>
            <div className='scratch-my-cards__card--table--row__text' style={ { right: '31px', 'text-align': 'right' } }>{ item.count } </div>
          </div>
        );
      }) }
    </Modal>
  );
};

PrizeInfoModal.propTypes = {
  message: PropTypes.string,
  modalClose: PropTypes.func,
  prizeData: PropTypes.array,
};

export default PrizeInfoModal;
